'use client';

import { SearchIcon, ClockWhite } from '../../../assets/icons';
import { useSearchParams } from 'next/navigation';
import { useEffect, useMemo, useRef, useState } from 'react';
import { Container, useModal } from '../..';
import {
  PartnerElementData,
  searchWorkAffiliate,
} from 'utils/affiliateHelpers';
import CustomLink from 'components/shared/CustomLink';
import Image from 'next/image';
import { ApplyMembershipTFModal } from './MembershipComponent';
import { analytics } from 'lib/analytics/analytics';
import { useTranslations } from 'next-intl';
import styles from './SearchCpmponent.module.css';

const SearchCard = (props: { className?: string } & PartnerElementData) => {
  const searchParams = useSearchParams();
  const routerQuery = useMemo(() => {
    const query: Record<string, string | string[]> = {};
    if (!searchParams) return query;
    for (const key of searchParams.keys()) {
      const values = searchParams.getAll(key);
      query[key] = values.length > 1 ? values : values[0];
    }
    return query;
  }, [searchParams]);
  return (
    <CustomLink
      href={{
        pathname: `/${props.code}`,
        query: routerQuery,
      }}
      className={styles.searchCard}
    >
      <span>{props.name ?? props.title}</span>
      {props.image ? (
        <Image
          src={props.image}
          alt={props.name}
          height="30"
          width="150"
          style={{ objectFit: 'contain', objectPosition: 'right' }}
        />
      ) : null}
    </CustomLink>
  );
};

export const SearchComponent = ({
  className,
  defaultSearchString,
}: {
  className?: string;
  defaultSearchString?: string;
}) => {
  const t = useTranslations('forWork');
  const ModalClient = useModal();
    const [search, setSearch] = useState<boolean>(false);
    const [searchString, setSearchString] = useState<string>(
      defaultSearchString ?? '',
    );
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const [searchResponse, setSearchResponse] =
      useState<Array<PartnerElementData> | null>(null);

    const autocompleteTimer = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
      if (!search) setSearchResponse(null);
    }, [search]);

    const onSearchClick = () => {
      setSearch(true);
    };

    const handleAutoSuggestion = (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchString(e.target.value);
      autocompleteTimer.current && clearTimeout(autocompleteTimer.current);

      if (e.target.value.length < 3) {
        setSearchResponse(null);
        return;
      }

      autocompleteTimer.current = setTimeout(() => {
        if (e.target.value.length >= 3) {
          setSearchResponse(null);
          setSearchLoading(true);
          searchWorkAffiliate(e.target.value)
            .then((res) => {
              if (res && res.data && res.data.length > 0)
                setSearchResponse(res.data);
              // else if (res.data && res.data.length === 0) setSearchResponse([]);
              else setSearchResponse([]);
            })
            .catch((e) => {
              console.log(e);
            })
            .finally(() => {
              setSearchLoading(false);
            });
        }
      }, 400);
    };

    const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      analytics.track(`header talk to expert - CLICK`);
      let url = 'website';
      if (window) {
        url = window.location.hostname + window.location.pathname;
      }
      ModalClient.set(
        <ApplyMembershipTFModal
          trackingParams={{
            utm_source: url,
            utm_medium: 'ultrawork-search-cta',
          }}
        />,
      );
      ModalClient.setCloseButtonTheme('light');
      ModalClient.show();
    };

    useEffect(() => {
      if (search) return;
      setSearchString('');
      setSearchResponse(null);
    }, [search]);

    useEffect(() => {
      console.log('searchResponse', searchResponse);
      console.log('search response length', searchResponse?.length);
    }, [searchResponse]);

    return (
      <div className={className ? `${styles.root} ${className}` : styles.root}>
        {search ? (
          <div
            className={styles.mask}
            onClick={() => setSearch(false)}
            role="button"
            tabIndex={0}
          />
        ) : null}
        {!search ? (
          <div className={styles.searchFood}>
            <input
              type="text"
              placeholder={t('search.placeholder')}
              onClick={onSearchClick}
              value={searchString}
              // onKeyDown={handleOnKeyDown}
            />
            <SearchIcon className={styles.search} fill="#ffffff" />
          </div>
        ) : (
          <div className={styles.searchFoodOverlay}>
            <input
              type="text"
              placeholder={t('search.placeholder')}
              onChange={handleAutoSuggestion}
            />
            <button
              className={styles.searchBtn}
              onClick={() => {
                setSearch(false);
              }}
            >
              {!searchLoading ? (
                <SearchIcon fill="#ffffff" />
              ) : (
                <ClockWhite fill="rgba(255,255,255,0.75)" />
              )}
            </button>
            {searchString.length > 0 ? (
              <Container style={{ padding: '0' }}>
                <div className={styles.suggestions}>
                  {searchResponse && searchResponse?.length > 0 ? (
                    <>
                      {searchResponse?.map((e: any, i: number) => {
                        return (
                          <>
                            <SearchCard key={i} {...e} />
                            <hr className={styles.elementDivider} />
                          </>
                        );
                      })}
                    </>
                  ) : null}
                  {searchResponse && searchResponse?.length === 0 ? (
                    <CustomLink
                      href="https://ultrahuman.com"
                      className={styles.applyMemCard}
                      onClick={handleLinkClick}
                    >
                      <span>{t('search.notFound')}</span>{' '}
                      <span className={styles.memCta}>{t('membership.requestAccess')}</span>
                    </CustomLink>
                  ) : null}
                </div>
              </Container>
            ) : null}
          </div>
        )}
      </div>
    );
};
